import { useBuildGroupsProvider } from '@/views/agents/components/buildGroups/buildGroups.helpers';
import { InjectionKey } from 'vue';

export const IKBuildGroup = Symbol('IKBuildGroup') as InjectionKey<ReturnType<typeof useBuildGroupsProvider>>;
